import { StatType, StatBox } from '@/components/landing/GrowingStats';
import { FullScreenLayout } from '@/components/layout/Layout';
import { Card } from '@/components/shadcn/card';
import { P } from '@/components/shadcn/typography';
import CoverageMap from '@/components/ui/map/CoverageMap';
import GeoCoder from '@/components/ui/map/Geocoder';
import useCoverageStats from '@/hooks/useCoverageStats';
import { MapContextProvider, useMap } from '@/hooks/useMap';

const CoverageStats = () => {
  const { data } = useCoverageStats();

  const coverageStats = {
    [StatType.TotalKmMapped]: data?.totalKmMapped ?? 0,
    [StatType.GlobalCoverage]: data?.globalCoverage ?? 0,
    [StatType.TotalUniqueKm]: data?.totalUniqueKm ?? 0,
  };

  return (
    <div className="flex w-full flex-row gap-4 md:w-auto md:flex-col">
      {Object.entries(coverageStats).map(([stat, value]) => (
        <StatBox
          key={stat}
          className="gap-2 p-3"
          textClassName="text-[8px] md:text-base"
          stat={stat as StatType}
          value={value}
        />
      ))}
    </div>
  );
};

const MapSearchAddon = () => {
  const { currentCoords, onGeocoderSelection, clearSearchMarker } = useMap();
  return (
    <div className="absolute right-4 top-[calc(var(--header-height))] mx-auto flex w-full max-w-xl flex-col items-end bg-transparent md:static">
      <GeoCoder
        placeholder="Search for a location"
        inputClassName="placeholder:text-neutral-300"
        className="z-0 animate-slideDown flex-row-reverse shadow-lg md:rounded-t-none md:border-t-0"
        onSelected={onGeocoderSelection}
        onClear={clearSearchMarker}
        proximity={currentCoords}
      />
    </div>
  );
};

const Page = () => {
  return (
    <MapContextProvider
      mapType="coverage"
      options={{
        enableStyles: false,
        enableSearch: false,
        enableSearchMarker: true,
        enableLocation: true,
        rememberLocation: true,
        extendedControlsClassName:
          'top-[calc(var(--header-height)+50px)] md:top-auto',
      }}>
      <FullScreenLayout headerAddon={<MapSearchAddon />}>
        <div className="absolute bottom-4 left-0 z-10 flex w-full flex-col gap-4 px-4 md:w-auto">
          <CoverageStats />
          <Card className="flex w-full flex-col items-center rounded border border-neutral-800 bg-neutral-900 p-4 shadow-lg md:w-[244px]">
            <div className="flex flex-col gap-2">
              <div className="flex items-center gap-2">
                <span
                  className="size-3 shrink-0 rounded-sm"
                  style={{ backgroundColor: '#22C55E' }}
                />
                <P className="text-sm font-normal leading-none">
                  High priority
                </P>
              </div>
              <div className="flex items-center gap-2">
                <span
                  className="size-3 shrink-0 rounded-sm"
                  style={{ backgroundColor: '#FF7A00' }}
                />
                <P className="text-sm font-normal leading-none">
                  Needs coverage
                </P>
              </div>
              <div className="flex items-center gap-2">
                <span
                  className="size-3 shrink-0 rounded-sm"
                  style={{ backgroundColor: '#3a6f7a' }}
                />
                <P className="text-sm font-normal leading-none">
                  Fresh coverage
                </P>
              </div>
            </div>
          </Card>
        </div>
        <CoverageMap
          includeContext={false}
          className="relative left-0 top-0 size-full"
        />
      </FullScreenLayout>
    </MapContextProvider>
  );
};

export default Page;
